import React from 'react';
import {Button, Card, Tooltip} from 'antd';
import {InfoCircleOutlined} from '@ant-design/icons';

import confirmAction from '../../../../helpers/confirmAction';

import '../../../../assets/less/Card.less';

interface StaffActionCardProps {
    action: () => void;
    cardTitle: string;
    toolTipMessage: string;
    confirmText: {
        title: string;
        description: string;
    } | null;
}

const StaffActionCard = ({
    action,
    cardTitle,
    toolTipMessage,
    confirmText,
}: StaffActionCardProps) => {

    const onClick = () => {
        return confirmText ?
        confirmAction(
            confirmText.title,
            confirmText.description,
            action,
        ) :
        action();
    };

    return (
        <Card
            className="details-card"
            title={
                <Tooltip
                    className="tool-tip"
                    trigger={['click', 'hover']}
                    placement="bottom"
                    title={toolTipMessage}
                >
                    <div className="question-tip">
                        <div>{cardTitle}</div>
                        <InfoCircleOutlined className="info-circle"/>
                    </div>
                </Tooltip>
            }
        >
            <Button
                danger
                htmlType="button"
                className="staff-action-button"
                onClick={onClick}
            >
                {cardTitle}
            </Button>
        </Card>
    )
};

export default StaffActionCard;
